import { IGif } from '@giphy/js-types'
import { uniqueId } from 'lodash'
import { Dimensions, Position } from 'types'
import { TextStyle } from '../../../types'
import { mediaInfoFromSource } from '../../../utils/media'
import { DEFAULT_CAPTION_STYLE } from '../constants'
import { UGELayer } from '../types'
import { measureText } from './text-measurements'

const PADDING = 20
const MAX_STICKER_SIZE = 200

export function getCaptionLayer(
    text: string,
    dimensions: Dimensions,
    style: Partial<TextStyle> = {},
    crop?: Position
): UGELayer {
    const { height, width } = measureText(text, { ...DEFAULT_CAPTION_STYLE, ...style })
    const dimensionsWidth = crop?.width || dimensions.width
    const dimensionsHeight = crop?.height || dimensions.height
    const maxWidth = dimensionsWidth - PADDING * 2
    const textWidth = Math.min(width, maxWidth)

    return {
        duration: 0,
        id: uniqueId('uge-text-layer-'),
        props: {
            ...DEFAULT_CAPTION_STYLE,
            ...style,
            text,
            width: textWidth,
            x: Math.round(dimensionsWidth / 2 - textWidth / 2) + (crop?.x || 0),
            y: Math.round(dimensionsHeight * 0.95) - height + (crop?.y || 0),
        },
        type: 'text',
    }
}

export async function getStickerLayer(
    gif: IGif,
    searchTerm: string,
    dimensions: Dimensions,
    crop?: Position
): Promise<UGELayer> {
    const source = gif.images.original.url
    const info = await mediaInfoFromSource(source)
    const aspectRatio = gif.images.original.width / gif.images.original.height
    const maxLayerSize = Math.min((crop?.height || dimensions.height) / 2, MAX_STICKER_SIZE)
    const artboardMidX = (crop?.width || dimensions.width) / 2
    const artboardMidY = (crop?.height || dimensions.height) / 2

    let width = maxLayerSize
    let height = Math.round(width / aspectRatio)

    if (height > maxLayerSize) {
        height = maxLayerSize
        width = Math.round(height * aspectRatio)
    }

    return {
        duration: info?.duration || 0,
        gifId: `${gif.id}`,
        id: uniqueId('uge-sticker-layer-'),
        name: gif.title,
        props: {
            height,
            source,
            width,
            x: Math.round(artboardMidX - width / 2) + (crop?.x || 0),
            y: Math.round(artboardMidY - height / 2) + (crop?.y || 0),
        },
        searchTerm,
        user: gif.user,
        thumbnailUrl: gif.images.fixed_height_still.url,
        type: gif.is_sticker ? 'sticker' : 'gif',
    }
}
